import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles/common.styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
        ${common.fullContainer};
        display: flex;
        flex-direction: column;
    `,
        main: css`
        ${custom.dashBoardRoot};
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        min-height: 0;
    `,
        header: css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: ${theme.spacing(2.5)};
        padding-bottom: ${theme.spacing(1)};
        margin-bottom: ${theme.spacing(3.75)};
        width: 100%;
        border-bottom: 1px solid ${theme.palette.primary.main};
    `,
        userLocationText: css`
        color: ${theme.typography.h3.color};
    `,
        container: css`
        display: flex;
        flex: 1 1 0;
        min-height: 0;
        width: 100%;
        overflow-y: auto;
        align-items: stretch;
        flex-direction: column;
        border-top: 1px solid ${theme.palette.secondary[50]};
    `,
        center: css`
        ${custom.border};
        display: flex;
        cursor: pointer;
        padding: 20px 40px;
        border-bottom: 1px solid ${theme.palette.secondary[50]};
        box-shadow: 1px 1px 1px #00000033;
    `,
        centerText: css`
        ${custom.messageText};
        font: normal normal normal 26px/32px Roboto;
    `,
        emptyState: css`
        ${custom.messageText};
        padding: ${theme.spacing(2.5, 5)};
    `,
        inlineLoader: css`
        display: flex;
        justify-content: center;
        padding: ${theme.spacing(2.5)};
    `,
    }
}

export default styles
